'use strict';
import * as $i_$0040ui5$002fwebcomponents$002fdist$002fOptionCustom$002ejs from "@ui5/webcomponents/dist/OptionCustom.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024 from "./com.raquo.laminar.codecs.package$.js";
import * as $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent from "./io.github.nguyenyou.ui5.webcomponents.laminar.shared.-Web-Component.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_OptionCustom$() {
  this.dz = null;
  this.cu = null;
  this.dV = null;
  this.dW = false;
  this.I7 = null;
  this.I8 = false;
  this.I9 = null;
  this.Ia = false;
  $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$ct_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent__T__(this, "ui5-option-custom");
}
export { $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_OptionCustom$ as $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_OptionCustom$ };
$p = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_OptionCustom$.prototype = new $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent();
$p.constructor = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_OptionCustom$;
/** @constructor */
function $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_OptionCustom$() {
}
export { $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_OptionCustom$ as $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_OptionCustom$ };
$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_OptionCustom$.prototype = $p;
$p.uB = (function() {
  if ((!this.I8)) {
    this.I7 = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "selected", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().gN));
    this.I8 = true;
  }
  return this.I7;
});
$p.uH = (function() {
  if ((!this.Ia)) {
    this.I9 = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "value", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().ci));
    this.Ia = true;
  }
  return this.I9;
});
$p.cQ = (function() {
  return $i_$0040ui5$002fwebcomponents$002fdist$002fOptionCustom$002ejs.default;
});
var $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_OptionCustom$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_nguyenyou_ui5_webcomponents_laminar_OptionCustom$, "io.github.nguyenyou.ui5.webcomponents.laminar.OptionCustom$", ({
  jF: 1,
  ac: 1
}));
export { $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_OptionCustom$ as $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_OptionCustom$ };
var $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_OptionCustom$;
function $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_OptionCustom$() {
  if ((!$n_Lio_github_nguyenyou_ui5_webcomponents_laminar_OptionCustom$)) {
    $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_OptionCustom$ = new $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_OptionCustom$();
  }
  return $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_OptionCustom$;
}
export { $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_OptionCustom$ as $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_OptionCustom$ };
